import styled from 'styled-components';

import { IconButton } from '@/ui/Button';
import { Select } from '@/ui/Select';
import { OptionTextStyled } from '@/ui/Select/atoms/Option/styles';

export const ActionsSelectButton = styled(IconButton).attrs({ icon: 'ellipsis-vertical' })``;

export const ActionOptionStyled = styled(Select.Option)<{ disabled?: boolean }>`
  & ${OptionTextStyled}, & [data-prefix] {
    opacity: ${({ disabled }) => (disabled ? 0.38 : 1)};
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  }
  & ${OptionTextStyled} {
    width: 100%;
  }
`;

export const ActionsListStyled = styled(Select.List)<{ $maxWidth?: string }>`
  max-width: ${({ $maxWidth }) => $maxWidth || '164px'};
`;
